export default __webpack_public_path__ + "static/media/Ies_Construlita.0f075fa7.png";